(function () {
  'use strict';

  const ESTIMATOR_SELECTOR = '[data-pincode-delivery-estimator]';

  function getIndiaDate() {
    const now = new Date();

    const indiaDateString = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(now);

    const parts = indiaDateString.split('-');

    return new Date(
      Number(parts[0]),
      Number(parts[1]) - 1,
      Number(parts[2])
    );
  }

  function addDays(date, days) {
    const result = new Date(date);

    result.setDate(result.getDate() + Number(days));

    return result;
  }

  function formatDate(date) {
    return new Intl.DateTimeFormat('en-IN', {
      timeZone: 'Asia/Kolkata',
      day: 'numeric',
      month: 'long'
    }).format(date);
  }

  function isValidPincode(pincode) {
    return /^[1-9][0-9]{5}$/.test(pincode);
  }

  function initializeEstimator(container) {
    if (container.dataset.initialized === 'true') {
      return;
    }

    container.dataset.initialized = 'true';

    const form = container.querySelector(
      '[data-pincode-delivery-form]'
    );

    const input = container.querySelector(
      '[data-pincode-input]'
    );

    const button = container.querySelector(
      '[data-pincode-check]'
    );

    const message = container.querySelector(
      '[data-pincode-message]'
    );

    const dataUrl = container.dataset.dataUrl;

    if (!form || !input || !button || !message || !dataUrl) {
      return;
    }

    let deliveryData = null;

    function showMessage(type, html) {
      message.className =
        'pincode-delivery-estimator__message is-' + type;

      message.innerHTML = html;
    }

    function clearMessage() {
      message.className =
        'pincode-delivery-estimator__message';

      message.innerHTML = '';
    }

    async function loadDeliveryData() {
      if (deliveryData !== null) {
        return deliveryData;
      }

      const response = await fetch(dataUrl, {
        method: 'GET',
        cache: 'force-cache'
      });

      if (!response.ok) {
        throw new Error('Unable to load delivery data.');
      }

      deliveryData = await response.json();

      return deliveryData;
    }

    async function checkPincode() {
      const pincode = input.value.trim();

      clearMessage();

      if (!isValidPincode(pincode)) {
        showMessage(
          'error',
          'Please enter a valid 6-digit PIN code.'
        );

        input.focus();

        return;
      }

      button.disabled = true;

      showMessage(
        'loading',
        'Checking delivery availability...'
      );

      try {
        const data = await loadDeliveryData();

        const delivery = data[pincode];

        if (!delivery) {
          showMessage(
            'error',
            'Sorry, delivery information is not available for this PIN code.'
          );

          return;
        }

        const minTat = Number(delivery.min);
        const maxTat = Number(delivery.max);

        if (
          !Number.isFinite(minTat) ||
          !Number.isFinite(maxTat)
        ) {
          showMessage(
            'error',
            'Delivery information is currently unavailable for this PIN code.'
          );

          return;
        }

        const today = getIndiaDate();

        const minDate = addDays(today, minTat);
        const maxDate = addDays(today, maxTat);

        const minDateFormatted = formatDate(minDate);
        const maxDateFormatted = formatDate(maxDate);

        let dateText;

        if (minTat === maxTat) {
          dateText =
            'You can receive this package by <span class="pincode-delivery-estimator__dates">' +
            minDateFormatted +
            '</span>.';
        } else {
          dateText =
            'You can receive this package between <span class="pincode-delivery-estimator__dates">' +
            minDateFormatted +
            '</span> and <span class="pincode-delivery-estimator__dates">' +
            maxDateFormatted +
            '</span>.';
        }

        showMessage(
          'success',
          '✓ ' + dateText
        );

        try {
          localStorage.setItem(
            'customer_pincode',
            pincode
          );
        } catch (storageError) {
          // Ignore localStorage errors.
        }

      } catch (error) {
        console.error(
          'Pincode delivery error:',
          error
        );

        showMessage(
          'error',
          'Unable to check delivery right now. Please try again.'
        );
      } finally {
        button.disabled = false;
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      checkPincode();
    });

    input.addEventListener('input', function () {
      input.value = input.value
        .replace(/\D/g, '')
        .slice(0, 6);

      clearMessage();
    });

    input.addEventListener('keypress', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkPincode();
      }
    });

    // Restore previously entered pincode.
    try {
      const savedPincode = localStorage.getItem(
        'customer_pincode'
      );

      if (savedPincode && isValidPincode(savedPincode)) {
        input.value = savedPincode;

        // Automatically check previously saved pincode.
        checkPincode();
      }
    } catch (storageError) {
      // Ignore localStorage errors.
    }
  }

  function initializeAllEstimators() {
    const estimators = document.querySelectorAll(
      ESTIMATOR_SELECTOR
    );

    estimators.forEach(function (container) {
      initializeEstimator(container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeAllEstimators
    );
  } else {
    initializeAllEstimators();
  }

  // Shopify Theme Editor support.
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      const estimators =
        event.target.querySelectorAll(
          ESTIMATOR_SELECTOR
        );

      estimators.forEach(function (container) {
        initializeEstimator(container);
      });
    }
  );
})();